
//* Style
import PreviewStyle from './style';
import Image from "@/components/common/Image";
import Text from "@/components/common/Text";

function formatDate(dateString) {
	const date = new Date(dateString);
	return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

const Preview = ({post}) => {
	const tempPost = post || {title: 'Blog Article name should be here lorem ipsum.', description: "In a world where meetings are key, Rewind and Twine help you stay.", created_at: "2025-02-17 19:13:18", image: { url: '/images/videoPreview.png' } }

	return (
		<PreviewStyle>
			<div className="preview-item">
				<Image className="preview-item-image" src={tempPost?.image?.url} alt={tempPost?.image?.alt}/>
				<div className="preview-item-text">
					<Text className={'h6 font-montserrat-medium'}>{tempPost.title}</Text>
					<Text className="text-gray preview-item-text-subTitle">
						{tempPost.description.replace(/<[^>]+>/g, '')}
					</Text>
					<Text className="text-gray preview-item-text-info">{formatDate(tempPost.created_at)}</Text>
				</div>
			</div>
		</PreviewStyle>
	);
};

export default Preview;
